/**
 * Toast store — spec §F2 ("Toast: bottom-centre dark pill, 3.4 s, single instance").
 * A tiny zustand slice rather than a context so any module (api error handlers, the
 * topbar language button) can call `toast()` without a React tree in scope.
 */
import { create } from 'zustand';

const DURATION_MS = 3400;

interface ToastState {
  message: string | null;
  /** Bumped on every call so a repeated identical message restarts the timer. */
  seq: number;
  show: (message: string, ms?: number) => void;
  hide: () => void;
}

let timer: ReturnType<typeof setTimeout> | null = null;

export const useToastStore = create<ToastState>((set) => ({
  message: null,
  seq: 0,
  show: (message, ms = DURATION_MS) => {
    if (timer) clearTimeout(timer);
    set((s) => ({ message, seq: s.seq + 1 }));
    timer = setTimeout(() => set({ message: null }), ms);
  },
  hide: () => {
    if (timer) clearTimeout(timer);
    set({ message: null });
  },
}));

/** Imperative helper — the mockup's `toast(msg, ms = 3400)`. */
export function toast(message: string, ms = DURATION_MS): void {
  useToastStore.getState().show(message, ms);
}
